import { Spin, Result } from 'antd';
import '../styles/loading.css';

const Loading = (props:any) =>{
  const {extraNameClass} =props;
    return(
      <Result className={extraNameClass} style={{display:'flex', flexDirection:'column', height:'89.8vh', justifyContent:'center', alignItems:'center', background:'none'}} icon={<div></div>}>
        <Spin size="large"/>
      </Result>  
    )
}
export default Loading;